import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { id: "services", label: "Services" },
  { id: "international", label: "Global" },
  { id: "corporate", label: "Corporate" },
  { id: "work", label: "Work" },
  { id: "contact", label: "Contact" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white border-b border-black/10" : "bg-white/85 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="section-gutter flex items-center justify-between h-16 md:h-20">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("top")}
          className="flex items-center gap-3 group"
        >
          <span className="w-6 h-6 grid grid-cols-2 grid-rows-2 shrink-0">
            <span className="bg-black" />
            <span className="bg-white border border-black" />
            <span className="bg-white border border-black" />
            <span className="bg-black" />
          </span>
          <span className="flex flex-col items-start leading-tight">
            <span className="overline">Black &amp; White Kampany</span>
            <span className="hidden sm:block text-[0.55rem] uppercase tracking-[0.22em] text-black/50 mt-0.5">
              A Narzis Ventures LLP company
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="nav-link text-[0.78rem] uppercase tracking-[0.18em] font-semibold text-black/80 hover:text-black"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta"
            onClick={() => scrollTo("contact")}
            className="btn-invert px-5 py-2.5 text-[0.7rem] uppercase tracking-[0.2em] font-bold"
          >
            Start a Campaign
          </button>
        </nav>

        <button
          data-testid="nav-toggle"
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden border-t border-black/10 bg-white"
          >
            <div className="section-gutter py-6 flex flex-col gap-5">
              {links.map((l) => (
                <button
                  key={l.id}
                  onClick={() => scrollTo(l.id)}
                  data-testid={`mobile-link-${l.id}`}
                  className="text-left text-sm uppercase tracking-[0.18em] font-semibold"
                >
                  {l.label}
                </button>
              ))}
              <button
                onClick={() => scrollTo("contact")}
                data-testid="mobile-cta"
                className="btn-invert px-5 py-3 text-xs uppercase tracking-[0.2em] font-bold mt-2"
              >
                Start a Campaign
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Nav;
